/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HotelEditSingleHasCheckinLimitApiRequest } from '../../models/hotel-edit-single-has-checkin-limit-api-request';

export interface ApiHotelManageEditSingleCheckinLimitPost$Params {
      body: HotelEditSingleHasCheckinLimitApiRequest
}

export function apiHotelManageEditSingleCheckinLimitPost(http: HttpClient, rootUrl: string, params: ApiHotelManageEditSingleCheckinLimitPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, apiHotelManageEditSingleCheckinLimitPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

apiHotelManageEditSingleCheckinLimitPost.PATH = '/api/hotel/manage/edit/single/checkin-limit';
